import { render, staticRenderFns } from "./ManageAwaitingAuditCorrectionListView.vue?vue&type=template&id=90045ebe"
import script from "./ManageAwaitingAuditCorrectionListView.vue?vue&type=script&lang=ts"
export * from "./ManageAwaitingAuditCorrectionListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports